'use strict';

import address from './address';
import billing from './billing';
// import multiship from './multiship';
import shipping from './shipping';
import cart from '../cart';

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
export default {
    init: function () {
    //address.init();
    if ($('.checkout-shipping').length > 0) {
        shipping.init();
        cart.addCouponCode();
    } else if ($('.checkout-multi-shipping').length > 0) {
        multiship.init();
    } else {
        billing.init();
        cart.addCouponCode();
    }

    //if on the order review page and there are products that are not available diable the submit order button
    if ($('.order-summary-footer').length > 0) {
        if ($('.notavailable').length > 0) {
            $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
        }
    }
    }
}